import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { Stack, CommandButton } from '@bingads-webui-react/fabric-control';

import { thridPartyMeasurementTrackingStyles } from '../../styles/third-party-measurement-setting-styles';


export const ThirdPartyTrackingRemoveAllButton = (props) => {
  const {
    i18n,
    removeAllVendorSettings,
    overrideStyles,
  } = props;

  const styles = useMemo(() => ({
    ...thridPartyMeasurementTrackingStyles,
    ...overrideStyles,
  }), [overrideStyles]);

  return (
    <Stack
      horizontalAlign="Right"
      verticalAlign="center"
      horizontal
      className="third-party-measurement-remove-all-stack"
      styles={styles.thirdPartyMeasurementRemoveAllStack}
    >
      <CommandButton
        className="third-party-measurement-remove-all-button"
        text={i18n.getString(_TL_('Remove All'))}
        styles={styles.thirdPartyMeasurementRemoveAllButton}
        onClick={removeAllVendorSettings}
      />
    </Stack>
  );
};

ThirdPartyTrackingRemoveAllButton.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  removeAllVendorSettings: PropTypes.func.isRequired,
  overrideStyles: PropTypes.shape({}),
};

ThirdPartyTrackingRemoveAllButton.defaultProps = {
  overrideStyles: {},
};
